import { render } from "./AposTiptapUndefined.vue?vue&type=template&id=20b56d4a&scoped=true"
import script from "./AposTiptapUndefined.vue?vue&type=script&lang=js"
export * from "./AposTiptapUndefined.vue?vue&type=script&lang=js"

import "./AposTiptapUndefined.vue?vue&type=style&index=0&id=20b56d4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b56d4a"],['__file',"rich-text-widget/ui/apos/components/AposTiptapUndefined.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20b56d4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20b56d4a', __exports__)) {
    api.reload('20b56d4a', __exports__)
  }
  
  module.hot.accept("./AposTiptapUndefined.vue?vue&type=template&id=20b56d4a&scoped=true", () => {
    api.rerender('20b56d4a', render)
  })

}


export default __exports__